import { useEffect } from "react";
const useGetMessage = () => {
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.origin === window.location.origin && event.data.id) {
        const message = event.data;
        console.log(message);
        // const id = message.id;
        // const description = message.description;
      }
    });
  }, []);
}

export const Child = () => {
  useGetMessage()

  return <div>Child</div>;
};
